import marketAnomalyService from '../../../../core/services/Market/MarketInDepth/MarketAnomalyService';
import Const from './Const';
import { keyBy } from 'lodash';
import { getDataFollowKeyByDot } from './../../../helpers/Common';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import priceDataService from './../../../../core/services/Prices/PriceData/PriceDataService';
import ConstCommon from './../../../common/Const';
import currentState from './../../../helpers/CurrentState';

const REDUCER_NAME = 'MARKET_IN_DEPTH:MARKET_ANOMALY:';
const TOGGLE_CHART_AND_TABLE = `${REDUCER_NAME}TOGGLE_CHART_AND_TABLE`;
const FETCH_LIST_DATA = `${REDUCER_NAME}FETCH_LIST_DATA`;
const CHANGE_FILTER_DATE_TIME = `${REDUCER_NAME}CHANGE_FILTER_DATE_TIME`;
const CHANGE_FILTER_YEAR = `${REDUCER_NAME}CHANGE_FILTER_YEAR`;
const CHANGE_CODE = `${REDUCER_NAME}CHANGE_CODE`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const FETCH_INFO_TYPE_SEARCH_TICKER = `${REDUCER_NAME}FETCH_INFO_TYPE_SEARCH_TICKER`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const SUBSCRIBE_REALTIME_DATA_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_TICK`;
const SUBSCRIBE_REALTIME_DATA_INDEX = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_INDEX`;

export {
  REDUCER_NAME,
  reducer as default,
  changeFilterDatetime,
  fetchListDataTable,
  toggleChartAndTable,
  changeFilterYear,
  changeCode,
  fetchInfoTypeSearchTicker,
  subscribeRealtimeTick,
  subscribeRealtimeIndex,
};

function subscribeRealtimeTick(data) {
  return {
    type: SUBSCRIBE_REALTIME_DATA_TICK,
    payload: data,
  };
}

function subscribeRealtimeIndex(data) {
  return {
    type: SUBSCRIBE_REALTIME_DATA_INDEX,
    payload: data,
  };
}

function fetchInfoTypeSearchTicker() {
  return (dispatch, getState) => {
    const { code } = getState()[REDUCER_NAME].currentSearch;

    priceDataService.getLatestPrice({ Code: code }).then(response => {
      let tickerInfomation = {};
      if (response.items) {
        tickerInfomation = response.items[0];
      }
      dispatch({
        type: FETCH_INFO_TYPE_SEARCH_TICKER,
        payload: {
          infoTicker: tickerInfomation,
        },
      });
    });
  };
}

function fetchListDataTable() {
  return (dispatch, getState) => {
    const { code } = getState()[REDUCER_NAME].currentSearch;
    const timeRange = getState()[REDUCER_NAME].currentYear;

    marketAnomalyService
      .getListAnomaly({ Code: code, TimeRange: timeRange })
      .then(response => {
        const items = response.items || [];
        const listDataTable = items.length > 0 ? items[0].anomalyItems : [];

        // can ignore anomalyItems in items[0]
        const indexData = items.length > 0 ? items[0] : {};

        dispatch({
          type: FETCH_LIST_DATA,
          payload: {
            listDataTable,
            indexData,
          },
        });
      });
  };
}

function toggleChartAndTable(isTable) {
  return {
    type: TOGGLE_CHART_AND_TABLE,
    payload: {
      isTable,
    },
  };
}

function changeFilterDatetime(key) {
  return {
    type: CHANGE_FILTER_DATE_TIME,
    payload: {
      key,
    },
  };
}

function changeFilterYear(key) {
  return dispatch => {
    dispatch({
      type: CHANGE_FILTER_YEAR,
      payload: {
        key,
      },
    });
    dispatch(fetchListDataTable());
  };
}

function changeCode(currentSearch) {
  return dispatch => {
    dispatch({
      type: CHANGE_CODE,
      payload: {
        currentSearch,
      },
    });
    const { code, displayCode, isTicker } = currentSearch;

    currentState.add(
      ConstCommon.listComponent.MarketInDepth,
      'anomaly.currentSearch',
      { code, displayCode, isTicker },
    );
    dispatch(fetchListDataTable());
    dispatch(fetchInfoTypeSearchTicker());
  };
}

const initialState = {
  averageData: [],
  listYearTable: [],
  listDataTableByYear: {},
  indexData: {},
  indexSumary: {},
  indexSumaryRealtime: {},
};

function reducer(globalState = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT: {
      const isTable = currentState.get(
        ConstCommon.listComponent.MarketInDepth,
        'anomaly.isTable',
      );
      return {
        ...globalState,
        ...initialState,
        isTable: isTable !== undefined ? isTable : false,

        currentSearch: currentState.get(
          ConstCommon.listComponent.MarketInDepth,
          'anomaly.currentSearch',
        ) || {
          code: Const.defaultCode,
          displayCode: Const.defaultCode,
        },
        currentFilterDatetime:
          currentState.get(
            ConstCommon.listComponent.MarketInDepth,
            'anomaly.currentFilterDatetime',
          ) || Const.listFilterDateTimeByKey.day.key,
        currentYear:
          currentState.get(
            ConstCommon.listComponent.MarketInDepth,
            'anomaly.currentYear',
          ) || Const.listFilterYearByKey.FiveYears.key,
      };
    }

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_LIST_DATA:
      const { listDataTable } = action.payload;

      const yearAverageFromServer = listDataTable.find(
        data => data[Const.listColumn.YEAR] === Const.yearAverageFromServer,
      );
      if (yearAverageFromServer) {
        yearAverageFromServer[Const.listColumn.YEAR] = Const.average;
        listDataTable.shift();
        listDataTable.push(yearAverageFromServer);
      }

      const listYearTable = listDataTable.map(item =>
        getDataFollowKeyByDot(item, Const.listColumn.YEAR),
      );

      const listDataTableByYear = keyBy(listDataTable, Const.listColumn.YEAR);
      const averageData = { ...listDataTable[listDataTable.length - 1] };

      return {
        ...globalState,
        listYearTable,
        listDataTableByYear,
        indexData: action.payload.indexData,
        averageData,
      };

    case CHANGE_FILTER_DATE_TIME:
      const currentFilterDatetime = action.payload.key;
      currentState.add(
        ConstCommon.listComponent.MarketInDepth,
        'anomaly.currentFilterDatetime',
        currentFilterDatetime,
      );
      return {
        ...globalState,
        currentFilterDatetime,
      };

    case FETCH_INFO_TYPE_SEARCH_TICKER:
      const { infoTicker } = action.payload;
      let indexSumary = {};
      if (Object.keys(infoTicker).length) {
        indexSumary = infoTicker.priceInfo || {};
      }

      return {
        ...globalState,
        indexSumary,
      };

    case TOGGLE_CHART_AND_TABLE:
      const { isTable } = action.payload;

      currentState.add(
        ConstCommon.listComponent.MarketInDepth,
        'anomaly.isTable',
        isTable,
      );

      return {
        ...globalState,
        isTable,
      };

    case CHANGE_FILTER_YEAR:
      const currentYear = action.payload.key;
      currentState.add(
        ConstCommon.listComponent.MarketInDepth,
        'anomaly.currentYear',
        currentYear,
      );
      return {
        ...globalState,
        currentYear,
      };

    case CHANGE_CODE:
      const { currentSearch } = action.payload;

      return {
        ...globalState,
        currentSearch,
        indexSumary: {
          ...globalState.indexSumary,
          tradingDate: null,
        },
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...globalState,
        component: action.payload,
      };

    case SUBSCRIBE_REALTIME_DATA_TICK:
      return {
        ...globalState,
        indexSumary: action.payload,
      };
    case SUBSCRIBE_REALTIME_DATA_INDEX:
      return {
        ...globalState,
        indexSumary: action.payload,
      };

    default:
      return globalState;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
